import { Link } from "react-router-dom";
import { Crown, Sparkles, Globe, ShieldCheck } from "lucide-react";

const JOURNEY = ["Application", "National Representative", "Continental Competition", "Preliminaries", "Semifinals", "Finals", "Miss United States of Africa"];
const VALUES = [
  { Icon: Sparkles, t: "Beauty & Culture", d: "Celebrating the diversity and elegance of every African nation." },
  { Icon: Crown, t: "Leadership", d: "Elevating women who lead change across the continent." },
  { Icon: Globe, t: "Unity", d: "One Africa, one people, one shared future." },
  { Icon: ShieldCheck, t: "Integrity", d: "Transparent voting, fair judging and verified results." },
];

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="section py-16 sm:py-24 text-center">
        <Crown className="mx-auto mb-5 h-10 w-10 text-gold" />
        <p className="kicker mb-3">Our Story</p>
        <h1 className="mx-auto max-w-4xl text-4xl sm:text-6xl text-amber-50 leading-tight">A New Era for African Excellence</h1>
        <p className="mx-auto mt-5 max-w-2xl text-lg text-amber-100/60">
          Miss United States of Africa is a continental celebration uniting beauty, culture, leadership and impact —
          giving every delegation a global stage and every woman a platform to change the world.
        </p>
      </section>

      <section className="border-y border-gold/15 bg-obsidian-800 py-16">
        <div className="section grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {VALUES.map((v) => (
            <div key={v.t} className="card-lux p-6">
              <v.Icon className="mb-3 h-6 w-6 text-gold" />
              <h3 className="text-lg text-amber-50">{v.t}</h3>
              <p className="mt-1 text-sm text-amber-100/60">{v.d}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="section py-16 sm:py-24">
        <p className="kicker mb-2 text-center">The Digital Crown Journey</p>
        <h2 className="mb-12 text-center text-3xl sm:text-4xl text-amber-50">From Application to the Crown</h2>
        <div className="mx-auto max-w-2xl">
          {JOURNEY.map((step, i) => (
            <div key={step} className="flex items-center gap-4">
              <div className="flex flex-col items-center">
                <span className={`flex h-10 w-10 items-center justify-center rounded-full font-mono text-sm ${i === JOURNEY.length - 1 ? "gold-bg text-obsidian" : "border border-gold/40 text-gold"}`}>{i + 1}</span>
                {i < JOURNEY.length - 1 && <span className="my-1 h-8 w-px bg-gradient-to-b from-gold/40 to-transparent" />}
              </div>
              <p className={`text-lg ${i === JOURNEY.length - 1 ? "gold-text font-serif text-2xl" : "text-amber-50/80"}`}>{step}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="section pb-24 text-center">
        <div className="glass rounded-2xl p-10">
          <h2 className="text-3xl text-amber-50">Join the movement</h2>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            <Link to="/candidates" className="btn-gold">Meet the Candidates</Link>
            <Link to="/vote" className="btn-ghost-gold">Vote Now</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
